// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sgQI","type":"styles_type__3KzMk","choices":"styles_choices__3RPXd"};